import React from "react";
import styled from "styled-components";
import {Image} from "../raw-components/image/image";
import {GameBox} from "../single-game/regular-template/boxes/game/game.box";
import {GameBox as JackpotGameBox} from "../single-game/jackpot-template/boxes/game/game.box";
import {GameTitleBox} from "../single-game/regular-template/boxes/game-title/game-title.box";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {GameImageContainerBox} from "../single-game/regular-template/boxes/game-image-container/game-image-container.box";
import {GameImageContainerBox as JackpotGameImageContainerBox} from "../single-game/jackpot-template/boxes/game-image-container/game-image-container.box";
import {GameDetailsContainerBox} from "../single-game/regular-template/boxes/game-details-container/game-details-container.box";
import {GameDetailsContainerBox as JackpotGameDetailsContainerBox} from "../single-game/jackpot-template/boxes/game-details-container/game-details-container.box";
import {AspectRatioContainerComponent} from "../raw-components/aspect-ratio-container/aspect-ratio-container.component";
import {JACKPOTS_ITEM, LIVE_STREAMING_ITEM, STATIC_VIDEO_ITEM} from "../../themes/css-global-classes";
import {VideoTileBox} from "../live-streaming-tile/video-common-components/video-tile/boxes/video-tile.box";
import {SkeletonAnimatedButton} from "../live-streaming-tile/video-common-components/video-tile-skeleton/skeleton-animated-button.box";
import {SkeletonAnimatedRectangle} from "../live-streaming-tile/video-common-components/video-tile-skeleton/skeleton-animated-rectangle.box";
import {VideoTileFooterBox} from "../live-streaming-tile/video-common-components/video-tile-footer/boxes/video-tile-footer.box";
import {VideoTileSkeletonbox} from "../live-streaming-tile/video-common-components/video-tile-skeleton/video-tile.skeletonbox";
import { CyClass } from "../../../common/cy-classes";
import { AmountContainerBox } from "./regular-template/boxes/amount-container/amount-container.box";

const DummyTextBox = styled.div`
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.25));
    background-size: 400px 100%;
    border-radius: 5px;
    animation: TextLoadingAnimation 1s linear infinite;

    @keyframes TextLoadingAnimation {
        0% {
            background-position-x: -200px;
        }
        100% {
            background-position-x: 200px;
        }
    }
`;

const DummyTextBoxAbsolute = styled(DummyTextBox)`
    position: absolute;
    top: 0;
    left: 25%;
    right: 25%;
    bottom: 0;
`;

interface IDummyTextBoxRelativeProps {
    small?: boolean;
}

const DummyTextBoxRelative = styled(DummyTextBox)<IDummyTextBoxRelativeProps>`
    position: relative;
    width: ${({small}) => small ? "50%" : "80%"};
    height: 2rem;
    margin-bottom: 1rem;
`;

export interface ISingleGameSkeletonComponentProps {
    templateType: string;
    useSquareIcons: boolean;
}

export class SingleGameSkeletonComponent extends OrbitComponent<ISingleGameSkeletonComponentProps> {

    private _getPlaceholderImageUrl = () => {
        if (this.props.useSquareIcons) {
            return this.services.theme.currentTheme?.images.gameIconPlaceHolderSq.toString();
        } else {
            return this.services.theme.currentTheme?.images.gameIconPlaceHolder.toString();
        }
    }
    private _renderRegularGameSkeleton() {
        return (
            <GameBox squareGameIcon={true} className={"swiper-mode"}>
                <GameImageContainerBox squareIcon={this.props.useSquareIcons} isLoading={true}>
                    <AspectRatioContainerComponent {...this.services.games.getGameImageExpectedSizes(this.props.useSquareIcons)} isLoading={true} />
                </GameImageContainerBox>
                <GameDetailsContainerBox squareGameIcon={this.props.useSquareIcons}>
                    <GameTitleBox>&nbsp;
                        <DummyTextBoxAbsolute/>
                    </GameTitleBox>
                    <AmountContainerBox>&nbsp;</AmountContainerBox>
                </GameDetailsContainerBox>
            </GameBox>
        );
    }

    private _renderJackpotGameSkeleton() {
        return (
            <JackpotGameBox>
                <JackpotGameImageContainerBox>
                    <AspectRatioContainerComponent {...this.services.games.getGameImageExpectedSizes(this.props.useSquareIcons)} isLoading={true}>
                        <Image src={this._getPlaceholderImageUrl()}/>
                    </AspectRatioContainerComponent>
                </JackpotGameImageContainerBox>
                <JackpotGameDetailsContainerBox>
                    <DummyTextBoxRelative/>
                    <DummyTextBoxRelative small/>
                </JackpotGameDetailsContainerBox>
            </JackpotGameBox>
        );
    }

    private _renderVideoSkeleton() {
        return (
            <VideoTileBox className={CyClass("cy-orbit-swiper-streaming-tile")}>
                <VideoTileSkeletonbox>
                    <AspectRatioContainerComponent width={16} height={9}>
                        <SkeletonAnimatedRectangle top right width={"25px"} height={"25px"} borderRadius={"50%"}/>
                        <SkeletonAnimatedRectangle bottom left width={"100px"} height={"25px"} borderRadius={"10px"}/>
                        <SkeletonAnimatedRectangle bottom right width={"100px"} height={"25px"} borderRadius={"2px"}/>
                    </AspectRatioContainerComponent>
                    <VideoTileFooterBox>
                        {this.services.mediaQuery.xlAndAbove ?
                            <SkeletonAnimatedButton width="135px" height="40px" borderRadius="20px" /> :
                            <SkeletonAnimatedButton width="115px" height="30px" borderRadius="15px" /> }
                    </VideoTileFooterBox>
                </VideoTileSkeletonbox>
            </VideoTileBox>
        );
    }

    render () {

        if (this.props.templateType === JACKPOTS_ITEM) {
            return this._renderJackpotGameSkeleton();
        }

        if ([LIVE_STREAMING_ITEM, STATIC_VIDEO_ITEM].includes(this.props.templateType)) {
            return this._renderVideoSkeleton();
        }

        return this._renderRegularGameSkeleton();
    }
}
